/**
 * User: herbert
 * Date: 20.04.16
 * Time: 12:54
 */

// the whole app is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */

import React from 'react';
//import ReactDOM from 'react-dom';
import Reflux from 'reflux';

import steleStore from '../../stores/stele-store.js';
import steleSVG from '../../SteleSVG.js';

import * as config from '../../../../config.js';
import '../../../../config-sizes.js'; // hier nicht mehr nötig falls Stele am Stück gezeichnet wird und die Berechnung von Size unten entfällt
import * as scssConfig from '../../../../config-scss.js';

import mapParts from './parts.jsx';

import T from '../../../../nls/translate.js';

export default React.createClass({
	propTypes: {
		steleRotation: React.PropTypes.number.isRequired,
		renderHeight: React.PropTypes.bool.isRequired,
		parentRefs: React.PropTypes.array.isRequired,
		childRefs: React.PropTypes.array.isRequired,
		datasheet: React.PropTypes.bool,
		zoom: React.PropTypes.bool,
	},
	mixins: [
		Reflux.connect(steleStore, 'data'), // this.state.data entspricht parameter von trigger() bei output: des stores,
		                                    // hier: ein Array mit StelePart-Elementen
	],
	getDefaultProps: function() {
		return {datasheet: false, zoom: false};
	},
	getInitialState: function() {
		return {};
	},
	componentDidUpdate: function() {
		this.updateRefs();
	},
	updateRefs: function() {
		const parentRefs = this.props.parentRefs;
		const childRefs = this.props.childRefs;
		parentRefs.length = 0;
		childRefs.length = 0;
		if(this.refs) {
			for (const key in this.refs) {
				// check also if property is not inherited from prototype
				if (this.refs.hasOwnProperty(key)) {
					const value = this.refs[key];
					if(!value) {
						console.log(key+' missing '+value);
						continue;
					}
					const keyParts = key.split('-');
					const p = parseInt(keyParts[1], 10);
					if(keyParts.length > 2) {
						// child
						childRefs[p] = childRefs[p] || [];
						childRefs[p][parseInt(keyParts[2], 10)] = value.getBoundingClientRect();
					} else {
						parentRefs[p] = value.getBoundingClientRect();
					}
				}
			}
		}
		//console.log("updateRefs", this.refs, parentRefs, childRefs);
	},
	render: function() {
		const activeStele = this.state.data.active;
		const fuellung = this.state.data !== null ? mapParts(activeStele, 0, null, this.props.steleRotation, undefined, true, null, this.props.datasheet) : null;

		const steleHeight = this.props.renderHeight ? scssConfig.stele_height_height_mm : scssConfig.stele_height_mm;
		const rhspHeight = this.props.datasheet ?
		((scssConfig.stele_height_height_mm-this.state.data.height)*scssConfig.stele_ds_height_px/scssConfig.stele_height_height_mm)+'px'		:
		((scssConfig.stele_height_height_mm-this.state.data.height)*scssConfig.stele_height_vh/scssConfig.stele_height_height_mm)+'vh';

		let size = 0;
		activeStele.forEach( part => {
			size+= config.PART_SIZES[part.name];
		});

		return (<div className="slx-stele__theThing">
			<img className="slx-stele__theThing__img"
			     src={steleSVG.getStele(steleHeight, size, (this.props.renderHeight ? this.state.data.height : null), this.props.datasheet, T.region === 'fr' || this.state.data.fr)} />
			{this.props.renderHeight ?
					<div key="rhsp" style={{width: '100%', height: rhspHeight}} /> :
					null}
			{fuellung}
		</div>);
	}
});
